import BaseApi from '@/api/controller/base';

const MARRIED_TO_API_URL = 'marriedTo/';

class MarriedToApi extends BaseApi {
  constructor() {
    super(MARRIED_TO_API_URL);
  }

  removeMarriage(primaryId) {
    return this.api.get(`${primaryId}/remove`);
  }
}

const apiInstance = new MarriedToApi();
export { MarriedToApi, apiInstance };
export default apiInstance;
